import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 * Componente para mostrar un resumen de permisos por módulo
 */
const PermissionSummary = ({ 
  usuario, 
  modulos, 
  permisos, 
  onEditPermissions, 
  canEdit 
}) => {

  // Función para obtener el ícono del permiso
  const getPermissionIcon = (permiso) => {
    const iconMap = {
      'vista': '👁️',
      'crear': '➕',
      'editar': '✏️',
      'eliminar': '🗑️',
      'exportar': '📤',
      'administrar': '👑',
      'Aprobar': '✅'
    };
    return iconMap[permiso] || '🔧';
  };

  // Función para obtener el nombre corto del módulo
  const getModuleShortName = (moduloName) => {
    const shortNames = {
      'conductores': 'Cond',
      'empresas': 'Emp',
      'rutas': 'Rut',
      'extras': 'Ext',
      'tarifarios': 'Tar',
      'mantenedores_generales': 'Gen',
      'usuarios': 'Usr',
      'estados_subestados': 'Est',
      'cierre': 'Cie'
    };
    return shortNames[moduloName] || moduloName.substring(0, 3).toUpperCase();
  };

  // Función para obtener el color del badge según la cantidad de permisos
  const getBadgeVariant = (permissionsCount, totalPermissions) => {
    const percentage = (permissionsCount / totalPermissions) * 100;
    if (percentage === 0) return 'dark';
    if (percentage < 30) return 'warning';
    if (percentage < 80) return 'info';
    return 'success';
  };

  if (!modulos || !usuario.modulos) {
    return (
      <div style={{ textAlign: 'center', color: '#c5872aff', fontSize: '12px' }}>
        Sin datos de permisos
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {modulos.map(modulo => {
        // Buscar los permisos del usuario para este módulo en la nueva estructura
        const userModulePermissions = usuario.modulos[modulo.modulo];
        
        // Si el módulo no existe en usuario.modulos, considerar que tiene 0 permisos
        const permissionsCount = userModulePermissions && userModulePermissions.permisos ? 
          userModulePermissions.permisos.length : 0;
        const totalPermissions = permisos.length;
        const variant = getBadgeVariant(permissionsCount, totalPermissions);

        // Crear tooltip con detalle de permisos (mostrar todos los módulos)
        const tooltip = (
          <Tooltip>
            <div style={{ textAlign: 'left' }}>
              <strong>{modulo.descripcion}</strong>
              <br />
              {userModulePermissions && userModulePermissions.permisos && userModulePermissions.permisos.length > 0 ? (
                <>
                  <small>Permisos ({permissionsCount}/{totalPermissions}):</small>
                  <ul style={{ margin: '4px 0', paddingLeft: '16px' }}>
                    {userModulePermissions.permisos.map(perm => (
                      <li key={perm.id} style={{ fontSize: '11px' }}>
                        {getPermissionIcon(perm.permiso)} {perm.permiso}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <small>Sin permisos asignados</small>
              )}
              {canEdit && <small><br />💡 Haz clic para editar</small>}
            </div>
          </Tooltip>
        );        return (
          <OverlayTrigger
            key={modulo.id}
            placement="top"
            overlay={tooltip}
          >
            <Badge
              bg={variant}
              style={{
                cursor: canEdit ? 'pointer' : 'default',
                fontSize: '10px',
                fontWeight: '500',
                padding: '4px 6px',
                transition: 'all 0.2s ease',
                userSelect: 'none'
              }}
              onClick={() => {
                if (canEdit && onEditPermissions) {
                  onEditPermissions(usuario, modulo.modulo);
                }
              }}
              onMouseEnter={(e) => {
                if (canEdit) {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                }
              }}
              onMouseLeave={(e) => {
                if (canEdit) {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = 'none';
                }
              }}
            >
              {getModuleShortName(modulo.modulo)} {permissionsCount > 0 && `(${permissionsCount})`}
            </Badge>
          </OverlayTrigger>
        );
      })}
    </div>
  );
};

export default PermissionSummary;
